import { styled } from 'styled-components';

export const ButtonContainer = styled.div<{ $minWidth?: string }>`
	height: 50px;
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: flex-end;
	min-width: ${({ $minWidth }) => $minWidth || 'unset'};
`;
